import { useRef, type ReactNode } from 'react';

import { useOption } from '@react-aria/listbox';
import { useListState } from '@react-stately/list';

import { cn } from '@simplywallst/ui-core/next';

export type ListBoxOptionItemProps = {
  className?: string;
  children: ReactNode;
};

type Props = {
  item: {
    key: string | number;
    rendered: ReactNode;
    props?: ListBoxOptionItemProps;
  };
  state: ReturnType<typeof useListState>;
};

export const Option = ({ item, state }: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const { optionProps, isFocused, isSelected } = useOption(
    { key: item.key, shouldFocusOnHover: true },
    state,
    ref
  );

  return (
    <li
      data-focused={isFocused ? 'true' : 'false'}
      data-selected={isSelected ? 'true' : 'false'}
      className={cn(
        'relative grid min-h-x5 grid-cols-[minmax(0,1fr)_min-content] items-center pr-x2',
        'cursor-pointer',
        'aria-selected:bg-[--s-field-input-popover-hover-color-bg]',
        'focus-within:bg-[--s-field-input-popover-hover-color-bg] data-[focused="true"]:bg-[--s-field-input-popover-hover-color-bg]',
        'focus-within:text-[--s-field-input-popover-hover-color-text] data-[focused="true"]:text-[--s-field-input-popover-hover-color-text]',
        item.props?.className
      )}
    >
      <div {...optionProps} ref={ref}>
        {item.rendered}
      </div>
    </li>
  );
};
